import { render, staticRenderFns } from "./Classic.vue?vue&type=template&id=e2ea1b0a&scoped=true&"
import script from "./Classic.vue?vue&type=script&lang=js&"
export * from "./Classic.vue?vue&type=script&lang=js&"
import style0 from "./Classic.vue?vue&type=style&index=0&id=e2ea1b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ea1b0a",
  null
  
)

export default component.exports